import React, { ComponentType, Suspense, createElement, useEffect, useLayoutEffect, useRef } from 'react';
import type { SwipeableDrawerProps } from '@mui/material';
import { ModalContainer, ModalLayout } from '@cp/ds/src/components/modalLayout';
import { ContentSkeleton } from '@cp/ds/src/components/contentSkeleton';
import { IModalWrapperProps } from './modal.interface';
import { ModalErrorBoundary } from './errorBoundary';
import { Drawer } from './drawer';

export interface IDrawerModalProps extends IModalWrapperProps, Pick<SwipeableDrawerProps, 'anchor'> {}
export const DrawerModal: React.FC<IDrawerModalProps> = ({
  ContentComponent,
  contentProps,
  anchor = 'bottom',
  open,
  onClose,
  onClosed,
}) => {
  useLayoutEffect(() => {
    Drawer.register('yh-drawer');
  }, []);
  const ref = useRef<Drawer>(null);
  useEffect(() => {
    if (ref.current) {
      ref.current.onClose = onClose;
      ref.current.onClosed = onClosed;
    }
  }, [onClose, onClosed]);
  return (
    /* @ts-expect-error custom element */
    <yh-drawer anchor={anchor} open={open} ref={ref}>
      <ModalErrorBoundary>
        <Suspense
          fallback={
            <ModalLayout>
              <ModalContainer>
                <ContentSkeleton blocks={2} />
              </ModalContainer>
            </ModalLayout>
          }
        >
          <ContentComponent {...contentProps} />
        </Suspense>
      </ModalErrorBoundary>
      {/* @ts-expect-error custom element */}
    </yh-drawer>
  );
};

export const withAnchor = (D: ComponentType<IDrawerModalProps>, anchor: 'right' | 'bottom') => (props: IModalWrapperProps) =>
  createElement(D, { ...props, anchor });
